export enum Paths {
    INDEX = "",
    NEW = "new"
}